<template>
  <div id="boothStatis">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'boothStatis'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/booth/BoothStatis.vue